<template>
  <div>
    <juicyscore v-if="!isDevelopment"></juicyscore>
    <div v-if="isDataReady">
      <designTopMenu
      class="isntMainWrap"
      :phone="phoneForProduct.view"
      :phoneForHref="phoneForProduct.href"
      ></designTopMenu>

      <uiTitle
        v-on:scrollingTo="WsScrollTo"
        :currentScreen="currentScreen"
      ></uiTitle>

     


       <div id="zform" class="alignPDL isntMainWrap" >
       
        <div class="sec_2">
          <div id="anketaSteps">
            <div id="screenFormLayout" >
              <screenFio
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'fio'"></screenFio>
              <screenSmsConfirm
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'smsConfirm'"></screenSmsConfirm>
              <screenPassport
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'passport'"></screenPassport>
              <screenWorkInfo
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'workInfo'"></screenWorkInfo>
              <screenPayment
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'payment'"></screenPayment>
              <screenSigningLoan
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'signingLoan'"></screenSigningLoan>
              <screenWaiting
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'waiting'"></screenWaiting>
              <screenThankYouPage
                v-on:scrollingTo="WsScrollTo"
                v-if="currentScreen === 'thankYouPage'"></screenThankYouPage>
              <screenRejection
                v-on:scrollingTo="WsScrollTo"
                v-on:toPdl="toPdl"
                v-if="currentScreen === 'rejection'"></screenRejection>
              <screenFullFail
                v-if="currentScreen === 'fullFail'"
                :loanInstReject="loanInstReject"
                :loanPDLReject="loanPDLReject"
              ></screenFullFail>
              <sceenCathError
                v-if="currentScreen === 'cathError'"
              ></sceenCathError>
              <screenVerificatorAwaiting
                v-if="currentScreen === 'verificationAwaiting'"
              ></screenVerificatorAwaiting>
            </div>




          </div>
          <div id="steps">
            <div class="nextStepBlock" v-show="currentScreenNumber > 0 && currentScreenNumber < 6">
              <p>Шаг {{currentScreenNumber}} из {{screenArrName.length}}</p>
              <button v-on:click="nextBlock($event)" class="instButton">следующий шаг</button>
            </div>
            <div class="nextStepBlock" v-show="currentScreenNumber >= 6 && currentScreenNumber < 7">
              <p>Шаг {{currentScreenNumber}} из {{screenArrName.length}}</p>
              <button v-on:click="nextBlock($event)" class="instButton">Завершить оформление</button>
            </div>
            <div id="agreementFio" v-if="currentScreen === 'fio'">
              <div id="agreementFioDesc">
                <div>
                  <img alt="" src="img/ico_10_lock.svg"/>
                </div>
                <span>Гарантируем безопасность и сохранность ваших данных</span>
              </div>
              <instCheckBox :fieldName="'AGREEMENT_PDL_UI_CONSENT_TO_PD'">
                <template v-slot:content>
                  <p>Подтверждаю достоверность введенных данных и даю согласие на обработку персональных данных
                    <a target="_blank" href="https://lnd.msk.finmoll.com/assets/pdf/consent_to_PD_processing.pdf">Подробнее</a>
                  </p>
                </template>
              </instCheckBox>
              <instCheckBox :fieldName="'AGREEMENT_PDL_UI_CONSENT_TO_ADVERT'">
                <template v-slot:content>
                  <p>Подтверждаю достоверность введенных данных и даю >согласие на получение рекламы
                  <a target="_blank" href="https://lnd.msk.finmoll.com/admd/upload/consentToAdvertising.pdf">Подробнее</a>
                </p>
                </template>
              </instCheckBox>
            </div>
          </div>
          <loader v-show="isLoading" ></loader>
        </div>
      </div> 
      
      <designInfoGetLoan
        class="isntMainWrap"
        :phone="phoneForProduct.view"
        :phoneForHref="phoneForProduct.href"
      ></designInfoGetLoan>

      <designOurAdvantages class="isntMainWrap"></designOurAdvantages>
    
      <uiUslovia></uiUslovia>

      <pdlFooter></pdlFooter> 

    </div>
    <loader v-else></loader>
  </div>



</template>
<script>
import "@/assets/css/fontRoboto.css";
import "@/assets/css/fontUbuntu.css";
import "@/assets/css/variable.css";
import "@/assets/css/instDesignLnd25.css";
import "@/assets/css/instInputs.css";

import {mapState, mapGetters} from 'vuex';
import tracing from '@/gavnoCode/tracing.js';

/* eslint-disable vue/no-unused-components */
const awaitObjectTemplate  = (sendData) => {
  return {
    stTime:new Date().getTime(),
    endTime:0,
    status:-1,// -1 поставлен в очередь. еще не запушен, 0 работает, 1 закончил работать
    error:0,//0 ошибков нет
    result:{},//что пришло
    data:sendData,//что отправили
  }
};

export default {
	name: "pdlLoan",
	data() {
		return {
      isDataReady: false,
      /**
       * screenArrName названия экранов формы, названия не менять!!!!
       */
			screenArrName:['fio' ,'smsConfirm' , 'passport' , 'workInfo', 'payment', 'signingLoan'],
      /**
       * sysScreenArrName системные названия экранов формы, названия не менять!!!!
       */
      sysScreenArrName:['thankYouPage', 'rejection','waiting','fullFail','verificationAwaiting'],
      loanInstReject:false,
      loanPDLReject:false,
			currentScreen:'fio',
			ConfirmationGUID: null,
      checksState:{
        GetAddressTerritory:[],
        GetAddressTerritoryAwaitList:[],
        clientCheck:[],
        clientCheckAwaitList:[],
      },
      /**
       * screenIfPdlTry string экран который покажется пользователю которому не судьба базовый но может попробовать pdl
       */
      screenIfPdlTry:'smsConfirm',
      loadFromEsia: false,
      repeatCl:false,
    }
	},
	components: {
		loader :() => import('@/views/pdlloan/uiLoader'),
		screenFio :() => import('@/views/pdlloan/formScreenFio'),
		screenSmsConfirm :() => import('@/views/pdlloan/formScreenSmsConfirm'),
    screenPassport: () => import('@/views/pdlloan/formScreenPassport'),
    screenWorkInfo: ()=>import('@/views/pdlloan/formScreenWorkInfo'),
		screenPayment:()=>import('@/views/pdlloan/formScreenPaymentSelector'),
    screenSigningLoan:()=>import('@/views/pdlloan/formScreenSigningLoan'),
    screenWaiting:()=>import('@/views/pdlloan/formScreenWaiting'),
    screenThankYouPage: ()=>import('@/views/pdlloan/formScreenTYpage'),
    screenRejection: ()=>import('@/views/pdlloan/formScreenRejection'),
    screenVerificatorAwaiting: ()=>import('@/views/pdlloan/formScreenVerificatorAwaiting'),
    screenFullFail: ()=>import('@/views/pdlloan/formScreenFullFail'),
    // uiProductAmountSelector: ()=>import('@/views/pdlloan/uiProductAmountSelector'),
    uiTitle: ()=>import('@/views/pdlloan/uiTitle'),
    uiHowTo: ()=>import('@/views/pdlloan/uiHowTo'),
    uiPreim: ()=>import('@/views/pdlloan/uiPreim'),
    uiUslovia: ()=>import('@/views/pdlloan/uiUslovia'),
    // uiContacts: ()=>import('@/views/pdlloan/uiContacts'),
    uiContactsWhite: ()=>import('@/views/pdlloan/uiContactsWhite'),
    sceenCathError:()=>import('@/views/pdlloan/formScreenCathError'),
    juicyscore:()=>import('@/components/pdl/juicyscore.vue'),
    designTopMenu: () => import('@/components/inst/design/topMenu.vue'),
    designInfoGetLoan: () => import('@/components/inst/design/infoGetLoan.vue'),
    designOurAdvantages: () => import('@/components/inst/design/ourAdvantages'),
    pdlFooter: () => import('@/components/pdl/footer.vue'),
    instCheckBox: () => import('@/components/inst/instCheckBox.vue'),
	},
	computed:{
		...mapState({
      pdlSelectedAmount:state=>state.Deal.pdlSelectedAmount,
			statusVuex      : state => state.Form.workData,
			valueVuex       : state => state.Form.sendData,
			isLoading       : state => state.Form.system.loading,

      pdlDeal: state=> state.Deal.pdlDeal,
      availablePeriods: state=> state.Deal.pdlPeriods,
      system: state=> state.Form.system,
      limitValue: state => state.Form.deal.limitValue
		}),
		...mapGetters([   'isAdressValid', 'getRedirectUrl','getSelectedDeal','getActiveMinDeal','getActiveMaxDeal']),
    /**
     * возвращает номер текущего экрана
     * @return int
     */
		currentScreenNumber(){
			return this.screenArrName.indexOf(this.currentScreen) + 1;
		},
    /**
     * вернет массив обхекто уникальных сумм
     * @returns array
     */
    availableSumKostilFormat(){
      let distinctSumm = [];
      let out = [];
      for (let i = 0; i < this.pdlDeal.length; i+=1){
        if (distinctSumm.indexOf(this.pdlDeal[i].Amount) <0 ){
          distinctSumm.push(this.pdlDeal[i].Amount);
        }
      }
      let tmp = distinctSumm.sort(function(a, b) {
        return a - b;
      });
      if (tmp.length >0) {
        for (let i = 0; i < tmp.length; i+=1){
          out.push({value: tmp[i], name: tmp[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")});
        }
      }
      return out;
    },
    /**
     * вернет массив обхектов уникальных периодов
     * @returns array
     */
    // availablePeriodsKostilFormat(){
    //   let out = [];
    //   for (let i = 0; i < this.availablePeriods.length; i+=1){
    //     out.push({value: this.availablePeriods[i], name: this.availablePeriods[i] < 52
    //         ?  this.availablePeriods[i] + ' дней'
    //         : this.availablePeriods[i] + ' недели'});
    //   }
    //   return out;
    // },
    phoneForProduct(){
      return {
        href:this.getSelectedDeal.vwIsPdl === '0' ? '88006009990' :'88006000685',
        view:this.getSelectedDeal.vwIsPdl === '0' ? '8 800 600 99 90' :'8 800 600 06 85'
      }
    },
    isDevelopment() {
      return process.env.NODE_ENV === 'development';
    }
	},
  watch:{
    currentScreen: async function (newValue,oldValue) {
      // !!!!!не забудь закомментировать перед пушем!!!!!
      // if(process.env.NODE_ENV === 'development') {
      //   /* eslint-disable no-unreachable */
      //   return ;
      // }

      if (this._pendingSave) {
        await this._pendingSave.catch(() => {});
        this._pendingSave = null;
      }

      await tracing.sendTrace();

      let sendData = {
        action: 166,
        session_id: window.session_id,
        token:window.token,
        new:newValue,
        old:oldValue,

      };

      if(oldValue==='smsConfirm' && newValue==='passport' && localStorage.getItem('ConfirmationGUID') !== null) {
        sendData.ConfirmationGUID = localStorage.getItem('ConfirmationGUID');

      }
      if(oldValue==='passport') {
        //запускаем кракена, на поиск лимита
        this.findLimit();
      }


      //todo this.valueVuex.CALC_WEEK !== 52 бомба отложенного действия, пока не появится новый продукт
      if(newValue === 'waiting' && this.getSelectedDeal.vwIsPdl === '1') {
        sendData.SendToken = localStorage.getItem('smsGuid');
      }

          if (isNaN(parseInt(localStorage.getItem('cid'),10))) {
            sendData.ClientId = 0;
          } else {
            sendData.ClientId = parseInt(localStorage.getItem('cid'),10);
          }

          if (localStorage.getItem('TraceIdWebix') !== null) {
            sendData.TraceIdWebix = localStorage.getItem('TraceIdWebix');
          }


      try {
        const res = await this.$axios.post(process.env.VUE_APP_URL_TRACE, sendData);
        if (!res?.data?.result) {
          throw new Error('result undefined')
        }
        if (res.data.errorCode !== 0) {
          throw new Error('errorCode !== 0')
        }

        this.fillLocalStorage(res.data.result);
        if (res.data.result.loan?.DemandId) {
          tracing.traceInput({
            action:165,
            refs:'DemandId',
            value:res.data.result.loan.DemandId
          });
        }

        if (!res.data.result.loan?.ClientId) {
          throw new Error('res.data.result.loan.ClientId undefined');
        }
      } catch(e) {
        console.log(e);
        this.currentScreen = 'cathError';
      }

      // // eslint-disable-next-line no-unused-vars
      // if(window.ym && this.screenArrName.indexOf(oldValue)){
      //   // eslint-disable-next-line no-undef
      //   ym(51632228,'reachGoal',oldValue);
      // }

      try {
        this.$external.traceInput({
          action:165,
          refs:'score_juicyscore_sessionId_errorMsg',
          value:'run window.juicyScoreApi.getSessionId()'
        });
        window.juicyScoreApi.getSessionId().then((sessionId) => {
          this.$external.traceInput({
            action:165,
            refs:'score_juicyscore_sessionId',
            value:sessionId
          });
        });
      } catch (e) {
        this.$external.traceInput({
          action:165,
          refs:'score_juicyscore_sessionId',
          value:null
        });
        this.$external.traceInput({
          action:165,
          refs:'score_juicyscore_sessionId_errorMsg',
          value:e.toString()
        });
        if (window.juicyScoreApi !== undefined) {
          this.$external.traceInput({
            action:165,
            refs:'score_juicyscore_sessionId_errorMsg',
            value:JSON.stringify(window.juicyScoreApi.apiEvents)
          });
        } else {
          this.$external.traceInput({
            action:165,
            refs:'score_juicyscore_sessionId_errorMsg',
            value:'window.juicyScoreApi undefined'
          });
        }
      }

    },
    'valueVuex.FIRST_NAME':function () {this.checkDataForRunClientCheck()},
    'valueVuex.LAST_NAME':function () {this.checkDataForRunClientCheck()},
    'valueVuex.SECOND_NAME':function () {this.checkDataForRunClientCheck()},
    'valueVuex.PHONE':function () {this.checkDataForRunClientCheck()},
    'valueVuex.RESIDENTIAL_ADDRESS':function () {
      // console.log(newValue)
      //если спалили что адрес получил данные то пришло наше время
      const checkAddress = this.isAdressValid('RESIDENTIAL_ADDRESS',false);
      //проверяем что адрес проходит валидацию(точность адреса до указанного дома
      if (checkAddress.length > 0) {
        //есть некие косяки, поэтому подсвечиваем пользователю что нужно добавить
        this.$store.dispatch('fieldError', {target: 'RESIDENTIAL_ADDRESS', value: checkAddress});
      } else {
        //запуск проверки
        this.launchInstanceCheck({
          action:'GetAddressTerritory',
          Address:this.valueVuex.RESIDENTIAL_ADDRESS,
          RESIDENTIAL_ADDRESS_DADATA:this.valueVuex.RESIDENTIAL_ADDRESS_DADATA,
          PartnerID: this.system.Partner_Id.toString()
        },'clientCheck');
      }

      this.$external.traceInput({
        action:165,
        refs:'RESIDENTIAL_ADDRESS',
        value:this.valueVuex.RESIDENTIAL_ADDRESS
      });
      this.$external.traceInput({
        action:165,
        refs:'RESIDENTIAL_ADDRESS_DADATA',
        value:this.valueVuex.RESIDENTIAL_ADDRESS_DADATA
      });
    },
    'valueVuex.REGISTRATION_ADDRESS':function(){
      this.$external.traceInput({
        action:165,
        refs:'REGISTRATION_ADDRESS',
        value:this.valueVuex.REGISTRATION_ADDRESS
      });
      this.$external.traceInput({
        action:165,
        refs:'REGISTRATION_ADDRESS_DADATA',
        value:this.valueVuex.REGISTRATION_ADDRESS_DADATA
      });
    },
    'valueVuex.WORK_JOB':function(){
      this.$external.traceInput({
        action:165,
        refs:'WORK_JOB',
        value:this.valueVuex.WORK_JOB
      });
      this.$external.traceInput({
        action:165,
        refs:'WORK_JOB_DADATA',
        value:this.valueVuex.WORK_JOB_DADATA
      });
    },
    'valueVuex.WORK_TITLE':function() {
      this.$external.traceInput({
        action: 165,
        refs: 'WORK_TITLE',
        value: this.valueVuex.WORK_JOB
      });
    },
    'valueVuex.WORK_TITLE_GIG_DATA':function (){
      this.$external.traceInput({
        action:165,
        refs:'WORK_TITLE_GIG_DATA',
        value:this.valueVuex.WORK_TITLE_GIG_DATA
      });
    },
    'valueVuex.CALC_SUMM':function () {
      this.$external.traceInput({
        action:165,
        refs:'CALC_SUMM',
        value:this.valueVuex.CALC_SUMM
      });
      localStorage.setItem('CALC_SUMM',this.valueVuex.CALC_SUMM);
    },
    'valueVuex.CALC_WEEK':function () {
      this.$external.traceInput({
        action:165,
        refs:'CALC_WEEK',
        value:this.valueVuex.CALC_WEEK
      });
      localStorage.setItem('CALC_WEEK',this.valueVuex.CALC_WEEK);
    },
    getSelectedDeal:function (newValue) {
      this.$external.traceInput({
        action:165,
        refs:'pdlGetSelectedDeal',
        value:newValue
      });
    }
  },
	methods:{
    findLimit(){
      setTimeout(()=>{
        if(parseInt(localStorage.getItem('DemandId'),10) > 0) {
          this.$axios({
            method: 'post',
            url: process.env.VUE_APP_URL_API_MS+'/checkLimit.php',
            data: {
              demandId: parseInt(localStorage.getItem('DemandId'),10),
              token: window.token,
              session_id:window.session_id
            }
          }).then((res) => {
            console.log(res)
            if(res.data.Error.Code === 0) {
              if(res.data.Data.Status === 'DONE' && parseInt(res.data.Data.FinalLimit,10) > 0) {
                this.$store.dispatch('setLimit',parseInt(res.data.Data.FinalLimit,10))
              }else{
                this.findLimit();
              }
            }
          }).catch((res)=>{
            console.log(res)
          });
        } else {
          this.findLimit();
        }
      }, 2000);
    },
    pushValuesToForm(arrValues,listFormFields){
      for(let i=0; i < listFormFields.length;i+=1) {
        try {
          if(arrValues[listFormFields[i]] !== undefined
            && arrValues[listFormFields[i]] !== null
            && arrValues[listFormFields[i]] !== ''){
            //ставим признак повторника, так себе, но есть причины
            this.repeatCl = true;
            this.$store.dispatch('saveSendData',{
              target:listFormFields[i],
              value: listFormFields[i].indexOf('_DADATA') >= 0 ?
                JSON.parse(arrValues[listFormFields[i]]) : arrValues[listFormFields[i]]
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    setPassportValues(data){



      let fields = [
        'BIRTHPLACE',
        'WORK_JOB',
        'EXPER_RADIO',
        'CREDHISTORY_RADIO',
        'CONST_INCOME',
        'OTHER_SOURCES_OF_INCOME',
      ]
      if(!this.loadFromEsia) {
        //если был контакт с гос услугами, то эти поля игнорим, нет оснований не доверять гос услугам!
        fields = fields.concat([
          'PASSPORT_DEP',
          'PASSPORT_DATE',
          'PASSPORT_NUMBER',
          'PASSPORT_SERIES',
          'PASSPORT_DEP_CODE',
          'RESIDENTIAL_ADDRESS_DADATA',
          'RESIDENTIAL_ADDRESS',
          'REGISTRATION_ADDRESS_DADATA',
          'REGISTRATION_ADDRESS',
          // 'IS_ADDRESS_COINCIDES', сломает форму
          'BIRTHDAY',
          'SNILS',
          'SOURCE_OF_INCOME',
          'EDUCATION',
          'MARITAL_STATUS',
          'MINOR_CHILDREN'
        ])
      }
      this.pushValuesToForm(data, fields);

      try {
        let extendedObj = JSON.parse(data['OTHER_JSON_DATA']);
          if(extendedObj?.extended != undefined) {
             this.pushValuesToForm(extendedObj.extended,[
              'EDUCATION',
              'CONTACT_PHONE',
              'MARITAL_STATUS',
              'MINOR_CHILDREN',
              'WORK_JOB_PHONE',
              'SOURCE_OF_INCOME',
              'FINANCIAL_POSITION',
              'PURPOSE_OF_THE_LOAN',
              'AVERAGE_EXPENSES_PER_MONTH',
               'SNILS'
            ]);
          }
       } catch (e) {
          console.log(e)
       }
    },
    setParamsDataFromUrl() {
      // /pdl?first_name=%D1%82%D0%B5%D1%81%D1%82&last_name=%D1%82%D0%B5%D1%81%D1%82&patronymic=%D1%82%D0%B5%D1%81%D1%82&phone=9032073848
      try {
        let fieldMapping = {
          'first_name': 'FIRST_NAME',
          'patronymic': 'SECOND_NAME',
          'last_name': 'LAST_NAME',
          'phone': 'PHONE',
          'email': 'EMAIL',
          'birthday': 'BIRTHDAY',
        };
        let mappedParams = {};

        for (let field in fieldMapping) {
          if (this.$route.query[field] !== undefined) {
            mappedParams[fieldMapping[field]] = this.$route.query[field];
          }
        }

        this.$store.dispatch('setParamsDataUrl', mappedParams);
      } catch (err) {
        console.log('Set params for input', err);
      }
    },
    toPdl(){
      if(this.limitValue > 0) {
          this.$store.dispatch('setLimit',this.limitValue).then(()=>{
            this.currentScreen = this.screenIfPdlTry;
          });
      } else {
        this.$store.dispatch('dealOnlyPdl');
        this.currentScreen = this.screenIfPdlTry;
      }

    },
    validatorArrField(arrChekedField, showError = true) {
      this.$external.consoleDebug('validatorArrField','open');
      this.$external.consoleDebug({arrChekedField});
      let result = true;
      arrChekedField.forEach(item => {
        this.$external.consoleDebug({item});
        if (this.statusVuex[item].code !== 0) {
          if (showError) {
            this.$store.dispatch('errorShow', {target: item, value: true,});
          }
          result = false;
        }
        this.$external.consoleDebug({result});
      });
      this.$external.consoleDebug('validatorArrField','close');
      return result;
    },
		validatorFio() {
      let fields = [
        'PHONE',
        'EMAIL',
        // 'RESIDENTIAL_ADDRESS',
        'SECOND_NAME',
        'LAST_NAME',
        // 'BIRTHDAY',
        'FIRST_NAME',
        // 'GENDER'
      ];
			let result = this.validatorArrField(fields);
      // const checkAddress = this.isAdressValid('RESIDENTIAL_ADDRESS');
      // if (checkAddress.length > 0) {
      //   this.$store.dispatch('fieldError', {target: 'RESIDENTIAL_ADDRESS', value: checkAddress});
      //   // this.$palantir.trackAction(116, 'RESIDENTIAL_ADDRESS');
      //   result = false;
      // }
      this.clickSaveData(fields);
			return result;
		},
    validatorPassport(){
      console.log('validatorPassport')
      let fields= [
        'PASSPORT_SERIES',
        'PASSPORT_NUMBER',
        'PASSPORT_DEP_CODE',
        'PASSPORT_DATE',
        'BIRTHPLACE',
        'REGISTRATION_ADDRESS',
        'RESIDENTIAL_ADDRESS',
        'PASSPORT_DEP',
        'SNILS',
        'BIRTHDAY',
        'GENDER'
      ];
      let result = this.validatorArrField(fields);
      let checkAdress = this.isAdressValid('REGISTRATION_ADDRESS');
      if (checkAdress.length > 0) {
        this.$store.dispatch('fieldError', { target: 'REGISTRATION_ADDRESS', value: checkAdress });
        result =  false;
        this.$palantir.trackAction(116,'REGISTRATION_ADDRESS');
      }
      let checkAddress = this.isAdressValid('RESIDENTIAL_ADDRESS');
      if (checkAddress.length > 0) {
        this.$store.dispatch('fieldError', {target: 'RESIDENTIAL_ADDRESS', value: checkAddress});
        // this.$palantir.trackAction(116, 'RESIDENTIAL_ADDRESS');
        result = false;
      }


      if(!this.loadFromEsia || !this.repeatCl){
        if(this.valueVuex['smartIdFileID'] === 0){
          this.$store.dispatch('errorShow', {
            target: 'smartIdFileID',
            value: true,
          });
          result = false;
        }
      }

      this.clickSaveData(fields);
      return result;
    },
    runSmsConfirmCheck(){
      return new Promise((resolve, reject) => {
        this.$store.dispatch('showLoading');
				this.$external.run({
					action: 'SMSConfirmationCodeCheck',
					ConfirmationGUID: localStorage.getItem('ConfirmationGUID'),
					ConfirmationCode: this.valueVuex['SmsConfCode'],
				}).then((res)=>{
					let resOb = res;
						if (resOb.ExecutionResult !== undefined) {
							if (resOb.ExecutionResult.CheckResult !== undefined) {
								if (resOb.ExecutionResult.CheckResult === true) {
                  //тут вставка, если заявка на верификации ни каких займов пдл, пока верификатор кнопку не жмякнет
                  let nextScreenName = 'passport';
                  console.log('resOb.ExecutionResult.Already_verif',resOb.ExecutionResult.Already_verif)
                  try {
                    if (resOb.ExecutionResult.Already_verif !== undefined && this.getSelectedDeal.vwIsPdl === '1') {
                      if(parseInt(resOb.ExecutionResult.Already_verif,10) > 0) {
                        nextScreenName = 'verificationAwaiting';
                      }
                    }
                  } catch (e){
                    console.log('try verificationAwaiting');
                  }
                  console.log('nextScreenName',nextScreenName)
									resolve(nextScreenName);
								} else {
									reject({
										ExecutionErrorCode: 2,
										ExecutionErrorMessage: 'Некорректный	код'
									});
								}
							}
						}
				}).catch((res)=>{
					if (res.ExecutionErrorCode !== undefined) {
            reject(res);
          } else {
            reject({
              ExecutionErrorCode: 3,
              ExecutionErrorMessage: 'Ошибка проверки кода sid=' + window.session_id
            });
          }
				}).finally(()=>{
					this.$store.dispatch('hideLoading');
        });

      });
    },
    pdlConfirmCodeCheck(){
      return new Promise(((resolve, reject) => {
        this.$external.consoleDebug('pdlConfirmCodeCheck','open');
        this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_TRACE,
          data: {
            action: 169,
            session_id: window.session_id,
            token: window.token,
            cid: parseInt(localStorage.getItem('cid'), 10),
            smsGuid:localStorage.getItem('smsGuid'),
            code:this.valueVuex['pdlSmsConfCode'],
            traceId:localStorage.getItem('traceId'),
          }
        }).then((res)=>{
          if (res.data !== undefined) {
            if (res.data.result !== undefined){
              if (res.data.result.Data !== undefined) {
                if (res.data.result.Data) {
                  resolve();
                } else {
                  reject();
                }
              }
            } else {
              reject();
            }
          } else {
            reject();
          }
        }).catch((res)=>{
          this.$external.consoleDebug(res);
          reject()
        }).finally(()=>{
          this.$external.consoleDebug('pdlConfirmCodeCheck','close');
        })
      }));
    },
    checkDataForRunClientCheck(){
      this.$external.consoleDebug('checkDataForRunClientCheck','open');
        const allFieldsReady = this.validatorArrField(['FIRST_NAME','LAST_NAME','SECOND_NAME','PHONE'], false);
        this.$external.consoleDebug({allFieldsReady});
        if (allFieldsReady) {
          this.launchInstanceClientEasyCheck();
        }
      this.$external.consoleDebug('checkDataForRunClientCheck','close');
    },
    timeOutInstanceCheck(action){
      this.$external.consoleDebug('timeOutInstanceCheck','open');
      const timeDelay = 3000;
      const currentIndex = this.checksState[action].length - 1;
      const currentObject = this.checksState[action][currentIndex];
      this.$external.consoleDebug({currentObject,currentIndex,action});
      if (currentObject.status < 0) {
       //текущая проверка еще не запущенна есть вариант, попробовать стартануть, при ином статусе проверка уже работает
        let timeNow = new Date().getTime();
        if ((timeNow - currentObject.stTime) > timeDelay) {
          currentObject.status = 0;
          this.$external.consoleDebug('external run');
            this.$external.run(currentObject.data).then(res=>{
              this.$external.consoleDebug('external run then');
              currentObject.result = res;
            }).catch(res=>{
              this.$external.consoleDebug('external run catch');
              currentObject.result = res;
              currentObject.error = 1;
            }).finally(()=>{
              this.$external.consoleDebug('external run finally');
              currentObject.endTime = new Date().getTime();
              currentObject.status = 1;
            });
        } else {
          this.$external.consoleDebug('timeOut');
          setTimeout(()=>{
            this.timeOutInstanceCheck(action);
          }, timeDelay);
        }
      }
      this.$external.consoleDebug('timeOutInstanceCheck','close');
    },
    launchInstanceCheck(sendData){
      this.$external.consoleDebug('launchInstanceCheck','open');
      const linkToState = Object.assign(this.checksState[sendData.action],[]);
      const objForWork = awaitObjectTemplate(sendData);

      if (linkToState.length === 0 || linkToState[linkToState.length - 1].status >= 0) {
        this.$external.consoleDebug('psuh');
        //если проверка еще не запускалась, или уже выполена или работает, то добавляем новую проверку в список
        linkToState.push(objForWork);
      } else {
        //иначе уже сужешствующую отменяем перезаписью новой
        this.$external.consoleDebug('update');
        linkToState[linkToState.length - 1] =  awaitObjectTemplate(sendData);
      }

      this.timeOutInstanceCheck(sendData.action);
      this.$external.consoleDebug('launchInstanceCheck','close');

    },
    launchInstanceClientEasyCheck(){
      this.launchInstanceCheck({
        action:'clientCheck',
        FirstName:this.valueVuex.FIRST_NAME,
        LastName:this.valueVuex.LAST_NAME,
        MiddleName:this.valueVuex.SECOND_NAME,
        Phone:this.valueVuex.PHONE,
        PartnerID: this.system.Partner_Id.toString()
      });
    },
    howClientWasChecked(arrCheckTypeRequired=[],awaitResult = false){


      return new Promise((resolve, reject) => {
        this.$external.consoleDebug('howClientWasChecked','open');
        const currentCheckState = this.checksState;
        let result = 0; //счетчик проверок, 0 все хорошо, > 0 клиент не подходит по проверке
        let i = 0;
        while(i < arrCheckTypeRequired.length){
          this.$external.consoleDebug('for i='+i,'open');
          this.$external.consoleDebug(currentCheckState[arrCheckTypeRequired[i]]);

          if (currentCheckState[arrCheckTypeRequired[i]] !== undefined) {
            let executeInstance = currentCheckState[arrCheckTypeRequired[i]];
            let lastExecuteInstance = executeInstance[executeInstance.length - 1];
            this.$external.consoleDebug({lastExecuteInstance,executeInstance});
            if (lastExecuteInstance.status === 0) {
              //если проверка сейчас работает
              if (awaitResult) {
                //и нужно дождаться когда она закончит работу, то запускаем себя же в рекурсии
                setTimeout(()=>{
                  this.howClientWasChecked(arrCheckTypeRequired,awaitResult).then(()=>resolve()).catch(()=>reject());
                }, 300);
              } else {
                //иначе выползаем из цикла, с псевдо ответом что все хорошо
                result = 0;
                i = arrCheckTypeRequired.length;
              }
            } else {
              //если проверка закончила работу, палим ошибки и нарашиваем счетчик косяков
              try {
                //ошибки выполнения скрипта или штатные коды отказа заведения заявки
                if (lastExecuteInstance.error > 0 || lastExecuteInstance.result.ExecutionError.ExecutionErrorCode !==
                  0) {
                  result += 1;
                }
              } catch (e) {
                  result += 1;
              }
            }
          }

          this.$external.consoleDebug('for i='+i,'close');
          i += 1;
        }
        if (result === 0) {
          resolve();
        } else {
          reject();
        }
        this.$external.consoleDebug('howClientWasChecked','close');
      })
    },
    clickSaveData(fields){
      let valuesFields = {};
      fields.forEach((key)=>{
        valuesFields[key] = this.valueVuex[key];
      });
      this._pendingSave = this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_TRACE,
          data: {
            action:170,
            token: window.token,
            session_id:  window.session_id,
            valuesFields: valuesFields
          }
      }).then((res)=>{
        console.log(res);
      }).catch(res=>{
        console.log(res);
      });
    },
		nextBlock() {
      let checkInputs;
			switch(this.currentScreen){
				case 'fio':
          if(this.validatorFio()) {
            // if(this.valueVuex.CALC_WEEK === 52) {
            //   this.howClientWasChecked(['GetAddressTerritory', 'clientCheck'])
            //   .then(() => {
            //     this.currentScreen = 'smsConfirm';
            //   }).catch(() => {
            //     this.screenIfPdlTry = 'smsConfirm';
            //     this.currentScreen = 'rejection';
            //   });
            // } else {
              this.currentScreen = 'smsConfirm';
            // }
					} else {
            this.WsScrollTo({id:'zform'});
          }
					break;
        case 'smsConfirm':
          if(this.validatorArrField(['SmsConfCode','ASP','AGREEMENT_KI_REQUEST'])) {
            this.runSmsConfirmCheck()
              .then((nextScreen)=>{
                this.currentScreen = this.screenIfPdlTry =  nextScreen;
              }).catch((res)=>{
                if(res.ExecutionErrorCode === 2) {
                  this.$store.dispatch('fieldError', {
                    target: 'SmsConfCode',
                    value: 'Некорректный	код'
                  });
                } else {
                  this.$store.dispatch('fieldError', {
                    target: 'SmsConfCode',
                    value: 'Не удалось проверить код, попробуйте позже. sid=' + window.session_id,
                  });
                }
            });
          } else {
            this.WsScrollTo({id:'zform'});
          }
          break;
        case 'passport':
          if (this.validatorPassport()){
            if (this.getSelectedDeal.vwIsPdl === '0') {
              this.howClientWasChecked(['GetAddressTerritory', 'clientCheck'])
              .then(() => {
                this.currentScreen = this.screenIfPdlTry = 'workInfo';
              }).catch(() => {
                this.screenIfPdlTry = 'workInfo';
                this.currentScreen = 'rejection';
              });
            } else {
              this.currentScreen = 'workInfo';
            }
          } else {
            this.WsScrollTo({id:'zform'});
          }
          break;
        case 'workInfo':
          checkInputs = ['WORK_JOB',
            'EXPER_RADIO',
            'CONST_INCOME',
            'EDUCATION',
            'MARITAL_STATUS',
            'MINOR_CHILDREN',
            'SOURCE_OF_INCOME',
            'PURPOSE_OF_THE_LOAN',
            'FINANCIAL_POSITION',
            'MY_OWN_BENEFIT',
            'ACTIONS_CONTROL',
            'NOT_RELATED',
          ];

          if (this.getSelectedDeal.vwIsPdl === '0') {
            checkInputs.push('MEETING_DATE');
            checkInputs.push('MEETING_HOUR');
          }

          if (this.validatorArrField(checkInputs)){
            if (this.getSelectedDeal.vwIsPdl === '0') {
              this.howClientWasChecked(['GetAddressTerritory', 'clientCheck'])
              .then(() => {
                this.currentScreen = 'waiting';
                this.screenIfPdlTry = 'payment';
              }).catch(() => {
                this.screenIfPdlTry = 'payment';
                this.currentScreen = 'rejection';
              });
            } else {
              // if(this.valueVuex['CALC_SUMM'] > 10000) {
              //   let newConstIncotme = parseInt(this.valueVuex['CONST_INCOME'], 10) * 3;
              //   newConstIncotme = newConstIncotme <= 150000 ? newConstIncotme : 150000;
              //   this.$store.dispatch('saveSendData',{
              //     target:'CONST_INCOME',
              //     value: newConstIncotme
              //   });
              //   this.$external.traceInput({
              //     action:165,
              //     refs:'CONST_INCOME',
              //     value: newConstIncotme
              //   });
              // }
              this.$store.dispatch('dealOnlyPdl');
              this.currentScreen = 'payment';
            }
          } else {
            this.WsScrollTo({id:'zform'});
          }
          break;
				case 'payment':

					if ( (this.valueVuex.PAYMENT_TYPE === 'TinkoffE2C' && this.valueVuex.tinkoffE2C_cardSelected.cardId !==
            undefined) ||
              (this.valueVuex.PAYMENT_TYPE === 'TinkoffA2C' && this.valueVuex.tinkoffA2C_bankSelected.memberName !==
                undefined) ) {
            this.currentScreen = 'signingLoan';
					}else {
            alert('Для перехода далее необходимо выбрать карту или банк для начисления денежных средств');
            this.WsScrollTo({id:'zform'});
					}
					break;
        case 'signingLoan':
           checkInputs = [
            'THIRD_PARTIES',
            'ACCEPTANCE_OF_THE_TERMS',
            'AGREEMENT_WITH_THE_RULES',
            'AGREEMENT_KI_REQUEST',
            'GENERAL_TERMS_OF_MICROLOAN',
            'RULES_FOR_MICROLOAN',
            'APPLICATION_MICROLOAN',
            'AGREEMENT_IU',
            'REQURENT_PAY',
            'pdlSmsConfCode',
            'AGREEMENT_PDL_UI_SIGN_LOAN'
          ];
          if(this.validatorArrField(checkInputs)) {
            this.pdlConfirmCodeCheck()
              .then(()=>{
                // // eslint-disable-next-line no-unused-vars
                // if (window.ym) {
                //   // eslint-disable-next-line no-undef
                //   ym(51632228,'reachGoal','pdlLoan') ;
                // }
                this.currentScreen = 'waiting';
              })
              .catch(()=>{
                this.$store.dispatch('fieldError', {
                  target: 'pdlSmsConfCode',
                  value: 'Некорректный	код'
                });
              });
          } else {
            this.WsScrollTo({id:'zform'});
          }
          break;
        case 'waiting':

          break;
        case 'thankYouPage':
          break;
        case 'rejection':
          break;
				default:
					alert('Ошибка в форме попытка переключения на экран ' +  this.currentScreen);
					break;
			}
		},
		WsScrollTo(obj, $event = false) {

      if (obj.event !== undefined && obj.event !== false) {
        obj.event.preventDefault();
      }
      if ($event !== false) {
        $event.preventDefault();
      }
      document.getElementById(obj.id).scrollIntoView({
        behavior: 'smooth',
      });
		},
    loadFromAnkets() {
      this.$external.consoleDebug('loadFromAnkets','open');
      let self = JSON.parse(localStorage.getItem('lcObject'));
      this.$external.consoleDebug(self);
      this.$external.consoleDebug('loadFromAnkets','close');
    },
    addChat(){
      let s;
      s = document.createElement('script');
      s.src = '//code.jivo.ru/widget/HlZ14RdVxQ';
      document.head.appendChild(s);
    },
    async sendTrace() {
      // условие, что для 165 экшена время с последнего вызова больше 3 сек
      const last = tracing.getLastTrace();
      if(last && last.action === 165 && Date.now() - last.ts_end < 3000) {
        setTimeout(async () => await this.sendTrace(), Date.now() - last.ts_end);
      } else {
        await tracing.sendTrace();
        setTimeout(async () => await this.sendTrace(), 3000);
      }
    },
    fillLocalStorage({sms, TraceId, loan}) {
      if (sms?.Data) {
        localStorage.setItem('smsGuid', sms.Data);
      }
      if (TraceId) {
        localStorage.setItem('traceId', TraceId);
      }
      if (loan) {

        if (loan.ClientId) {
          localStorage.setItem('cid', loan.ClientId);
        }
        if (loan.DemandId) {
          localStorage.setItem('DemandId', loan.DemandId);
        }
        if (loan.TaskScoring) {
          localStorage.setItem('TaskScoring',loan.TaskScoring);
        }
        if (loan.TraceId) {
          localStorage.setItem('TraceIdWebix',loan.TraceId);
        }
        if (loan.Data) {
          this.setPassportValues(loan.Data);
        }
        // if (loan.IsNewClient) {
        //   // акция для новых клиентов н
        //   this.$store.commit('setSaleForVirgin')
        // }
      }
    },
    async getEsiaToken(code) {
      const params = {
        grant_type: 'authorization_code',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        client_id: process.env.VUE_APP_ID_ESIA,
        code,
        client_secret: process.env.VUE_APP_SECRET_ESIA
      }
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/token, ${JSON.stringify(params)}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/token`, { ...params })
        this.$palantir.trackAction(177, `fromESIA - getEsiaToken - ${JSON.stringify(data)}`);
        return data.access_token
      } catch(e) {
        console.log(e)
      }
    },
    async getCpg(access_token) {
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/userinfo, ${JSON.stringify({ headers: { 'Authorization': 'Bearer ' + access_token} })}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/userinfo `, {}, { headers: { 'Authorization': 'Bearer ' + access_token} })
        this.$palantir.trackAction(177, `fromESIA - getCpg - ${JSON.stringify(data)}`);
        return data.info
      } catch(e) {
        console.log(e)
      }
    },
    async saveDadataAddress(refs) {
      const { data } = await this.$myApi.suggestResult(
        refs,
        { 'value': this.valueVuex[refs], 'type': refs })
      if(data.result.suggestions.length > 0) {
        this.$store.dispatch('saveSendData', {
          target: refs + '_DADATA',
          value: data.result.suggestions[0],
        });
        this.$store.dispatch('saveSendData', {
          target: refs,
          value: data.result.suggestions[0].value
        });
      } else {
        this.$palantir.trackAction(176, this.valueVuex[refs]);
      }
    },
    activityEsiaProductRecoveryCheckOlds(target){
      if(localStorage.getItem(target) !== null) {
        localStorage.setItem('pre'+target,localStorage.getItem(target));
      }
    },
    activityEsiaProductRecoverySet(target){
      if(localStorage.getItem('pre'+target) !== null){
        const value = parseInt(localStorage.getItem('pre'+target),10);
        if(value > 0) {
          this.$store.dispatch('saveSendData', {
            target: target,
            value: value
          });
        }
      }
    },
    activityEsiaProductRecovery(){
      //для особых хотелок, если до авторизации на госуслугах, трогали сумму, то эту сумму подставляем в эту сессию
      //с оттяжекой, что бы вся херня успела прогрузиться и пропихнуться
      setTimeout(()=>{
        this.activityEsiaProductRecoverySet('CALC_SUMM');
        this.activityEsiaProductRecoverySet('CALC_WEEK');
      },666);
    },
    activityEsia(){
      //маркер пользователь потрогал, гос услуги
      this.$external.traceInput({
        action:165,
        refs:'activityEsia',
        value: true
      });
      this.activityEsiaProductRecovery();
    },
    getFromNsk(){
      const nskAlias = [
        {nsk:'lastName', msk:'LAST_NAME'},
        {nsk:'firstName', msk:'FIRST_NAME'},
        {nsk:'middleName', msk:'SECOND_NAME'},
        {nsk:'phone', msk:'PHONE'},
        {nsk:'email', msk:'EMAIL'},
        {nsk:'passportSerie', msk:'PASSPORT_SERIES'},
        {nsk:'passportNumber', msk:'PASSPORT_NUMBER'},
        {nsk:'passportIssueDate', msk:'PASSPORT_DATE'},
        {nsk:'birthPlace', msk:'BIRTHPLACE'},
        {nsk:'birthPlace', msk:'BIRTHPLACE'},
        {nsk:'orgName', msk:'WORK_JOB'},
        {nsk:'orgPosition', msk:'WORK_TITLE'}
        // {nsk:'address', msk:'WORK_TITLE'}
      ];

      try {
        if(this.$route.query.subid) {
          this.$axios({
            method: 'post',
            url: process.env.VUE_APP_URL_API_MS + '/getNskData.php',
            data: {
              token: this.system.token,
              session_id:this.system.session_id,
              guid:this.$route.query.subid
            }
          }).then((res)=>{
            const workData = res?.data?.result?.client;
            if(workData && Object.keys(workData).length > 0 && workData.constructor === Object) {
              nskAlias.forEach((item)=>{
                if(workData[item.nsk] !== undefined && workData[item.nsk] != null){
                  this.$store.dispatch('saveSendData',{
                    target:item.msk,
                    value:workData[item.nsk]
                  })
                }
              });
            }
            if(this.$route.query.sub1 && parseInt(this.$route.query.sub1,10) > 0 && this.$route.query.sub1 % 1000 === 0){
              const addCalcSumm = parseInt(this.$route.query.sub1,10);
              if (addCalcSumm >= this.getActiveMinDeal && addCalcSumm <= this.getActiveMaxDeal) {
                this.$store.dispatch('saveSendData',{
                  target:'CALC_SUMM',
                  value:addCalcSumm
                })
              }
            }
          }).catch((res)=>{
            console.log(res)
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    importDataFromPartner(){
      switch(this.system.Partner_Id) {
        case 10004:
          this.getFromNsk();
          break;
        case 10006:
          this.getFromNsk();
          break;
        default:
          break;
      }

    },
    // testLimit(){
    //   // this.testLimitCase1(60000,8000);
    //   // this.testLimitCase2(60000,8000);
    //   this.testLimitCase3(7000,8000);
    // },
    // testLimitCase3(_userSumm,_limit){
    //   this.testLimitSetSumm(_userSumm)
    //
    //   .then(this.testLimitSetLimit(_limit))
    //       .then(this.testLimittoSign)
    // },
    // /*
    // сценарий, если оформляли базовый, но пришел отказ и пользователь поперся заполнять пдл, лимит приперся на экране подписания
    //  */
    // testLimitCase2(_userSumm,_limit){
    //   this.testLimitSetSumm(_userSumm)
    //       .then(this.testLimitGotReject)
    //       .then(this.testLimitClickPdl)
    //       .then(this.testLimittoSign)
    //       .then(this.testLimitSetLimit(_limit))
    // },
    // /*
    // сценарий, если оформляли базовый, но пришел отказ и пользователь поперся заполнять пдл, лимит уже есть
    //  */
    // testLimitCase1(_userSumm,_limit){
    //   this.testLimitSetSumm(_userSumm)
    //       .then(this.testLimitSetLimit(_limit))
    //       .then(this.testLimitGotReject)
    //       .then(this.testLimitClickPdl)
    //       .then(this.testLimittoSign)
    // },
    // testLimitSetSumm(_summ){
    //   return new Promise((resolve)=>{
    //     console.group('testLimitSetSumm')
    //     setTimeout(()=>{
    //       this.$store.dispatch('saveSendData', {
    //         target: 'CALC_SUMM',
    //         value: _summ
    //       });
    //       console.log('testLimitSetSumm')
    //       console.groupEnd('testLimitSetSumm')
    //       resolve();
    //     },500)
    //   })
    // },
    // testLimitSetLimit(_summ){
    //   return new Promise((resolve)=>{
    //     console.group('testLimitSetLimit')
    //     setTimeout(()=>{
    //       this.$store.dispatch('setLimit',_summ)
    //       console.log('testLimitSetLimit')
    //       console.groupEnd('testLimitSetLimit')
    //       resolve();
    //     },500)
    //   })
    // },
    // testLimitGotReject(){
    //   return new Promise((resolve)=>{
    //     console.group('testLimitGotReject')
    //     setTimeout(()=>{
    //       this.currentScreen='rejection';
    //       console.log('testLimitGotReject')
    //       console.groupEnd('testLimitGotReject')
    //       resolve();
    //     },500)
    //   })
    // },
    // testLimitClickPdl(){
    //   return new Promise((resolve)=>{
    //     console.group('testLimitClickPdl')
    //     setTimeout(()=>{
    //       this.toPdl();
    //       console.log('testLimitClickPdl')
    //       console.groupEnd('testLimitClickPdl')
    //       resolve();
    //     },500)
    //   })
    // },
    // testLimittoSign(){
    //   return new Promise((resolve)=>{
    //     console.group('testLimittoSign')
    //     setTimeout(()=>{
    //       this.currentScreen='signingLoan'
    //       console.log('testLimittoSign')
    //       console.groupEnd('testLimittoSign')
    //       resolve();
    //     },500)
    //   })
    // },
  },
	async mounted(){

    // eslint-disable-next-line no-unused-vars
    if (window.ym){
      // eslint-disable-next-line no-undef
      ym(97209094, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
      // // eslint-disable-next-line no-undef
      // ym(51632228,'reachGoal','enter23');
    }
    this.activityEsiaProductRecoveryCheckOlds('CALC_SUMM');
    this.activityEsiaProductRecoveryCheckOlds('CALC_WEEK');

    localStorage.removeItem('cid');
    // let self = this;
    this.$axios({
      method: 'post',
      url: process.env.VUE_APP_URL_SESSION,
      data: {
        location:document.location.href,
        localStorage:localStorage.getItem('lcObject'),
        token: this.$route.query.state,
        referrer: document.referrer,
      }
    }).then(res=>{
      // Получаем дефолтные параметры для лида. Важные, что пипец
      this.$store.commit('setGuid', res.data.result.guid);
      this.$store.commit('setPartnerId', res.data.result.Partner_Id);
      sessionStorage.setItem('session_id', res.data.result.session_id);
      sessionStorage.setItem('token', res.data.result.token);
      window.session_id = res.data.result.session_id;
      window.token = res.data.result.token;
      window.guid = res.data.result.guid;
      window.Partner_Id = res.data.result.Partner_Id;

      // if(window.Partner_Id === 0){
      //   document.location.href = 'https://lnd.msk.finmoll.com/admd/?Partner_Id=3'
      // }
      //Кто прочитает, и напише нахуа, будет молодец
      if (res.data.result.deal !== undefined){
        this.$store.dispatch('deal23',res.data.result.deal)
      }
      //важные параметры, что бы сохранить в хранилише браузера, пригодится когда открываются новые вкладки, но это не точно
      let lcObject = {
        session_id:  window.session_id,
        guid: this.system.guid,
        utm: res.data.result.utm,
        Partner_Id: this.system.Partner_Id,
        token:  window.token ,
      };
      if (process.env.VUE_APP_FORM_TEST === 'true') {
        lcObject.session_id = 5468868;
        sessionStorage.setItem('session_id', lcObject.session_id);
        lcObject.token = 'CD99B9F2-C0AC-DD65-0177-8DB6FC6C297F';
        sessionStorage.setItem('token', lcObject.token)
      }
      localStorage.setItem('lcObject',JSON.stringify(lcObject));

      //Что-то пошло не так с госуслугами, запишем
      if(this.$route.query.error) {
        this.$palantir.trackAction(175, this.$route.query.error_description);
        this.$router.replace({ query: {} })
      }

      if (this.$route.query.code) {
        this.$palantir.trackAction(177, `fromESIA - ${JSON.stringify(this.$route.fullPath)}`);
        const code = this.$route.query.code;
        this.$router.replace({ query: {} });

        this.getEsiaToken(code).then(access_token => {
          this.getCpg(access_token).then(userInfo => {
            this.activityEsia();
            this.$store.dispatch('saveEsiaInfo', userInfo);
            this.saveDadataAddress('RESIDENTIAL_ADDRESS');
            this.saveDadataAddress('REGISTRATION_ADDRESS');
            this.loadFromEsia = true;
            this.WsScrollTo({id:'zform'});
          })
        })
      }
      this.isDataReady = true;

      this.importDataFromPartner();

    }).catch(res=>{
      console.log(res);

      // document.location.reload();
    });
    if (!this.isDevelopment) {
      this.addChat();
    }

    this.setParamsDataFromUrl();

    setTimeout(async () => await this.sendTrace(), 3000);
    // if(process.env.NODE_ENV == 'development'){
    //   setTimeout(() => this.testLimit(), 3000);
    // }
	},
  created(){
    window.addEventListener('focus',this.loadFromAnkets)
  }
}
</script>
<style>

html, body {
  margin: 0;
  padding: 0;
  font-family: 'Ubuntu';
  font-weight: 500;
}


#zform{background: white;padding: var(--font-size-30) 0;border-radius: var(--font-size-20);}

.sec_2{padding: 0 var(--font-size-20);}
.nextStepBlock{display: flex;align-items: center;justify-content: space-between;}
.nextStepBlock .instButton{margin:0}

#agreementFio{padding:var(--font-size-40) 0 var(--font-size-20);color:var(--color-gray-type1)}

#agreementFioDesc{display: flex;align-items: center;justify-content: flex-start;}
#agreementFioDesc img{width: var(--font-size-20);height: auto;margin: 0 0 0 var(--font-size-08);}
#agreementFioDesc > div{width: var(--font-size-47);}

@media screen and (min-width: 760px) {
  .sec_2{padding: 0;width: var(--font-size-760);margin: 0 auto;}
 
  #agreementFioDesc span{width: auto;}
}


@media screen and (min-width: 1170px) {
  
}

/* /*стили для полей* / */
/* .errorMsg { color: red; font-size: 2.87vw; pointer-events: none;position: absolute; background: white;padding: 0 1.60vw; top: 11vw; left: 2.28vw } */
/* .inputBoxWrap { position: relative } */
/* .inputBoxWrap > input{ padding: 4.41vw 5.88vw 4.41vw 5.88vw; margin-bottom: 4.71vw; font-size: 3.47vw; border: 1px */
/* solid #D5D5D5; border-radius: 10px ;width: calc(100% - 11.76vw);} */
/* .inputBoxWrap label { position: absolute; padding: 0 2.67vw ; top: 1px; font-size: 2.87vw; border-top-left-radius: 10px; */
/*   color: #869A95; pointer-events: none; transition: 0.3s ease-out; background: #FFFFFF; left: 2.28vw} */
/* input { display: block; width: 100%;  transition: 0.3s ease-out } */
/* input[type=date] { /* height: 1.5rem; */ 
/*} */
/* input:focus ~ label { top: -2vw } */
/* /deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -2vw } */
/* /*остальные стили* / */

/* select,input{background: inherit} */

/* h2 { font-size: 5.29vw } */
/* h3 { color: #222721; font-size: 4.41vw } */
/* p { font-size: 3.53vw } */
/* a { color: #43AC34 } */
/* span { font-size: 2.35vw } */
/* div { font-size: 3.53vw } */
/* label { font-size: 2.94vw } */

/* * { font-family: "Lato-Regular" } */
/* /*.align { margin: unset; width: auto }* / */
/* .alignPDL {  } */
/* button { font-family: 'Lato-Regular'; font-size: 3.53vw } */
/* .fontBold { font-family: 'Lato-Bold' } */
/* #steps { padding: 5.88vw } */
/* #steps > div { margin-bottom: 6.93vw; display: flex; align-items: center; flex-direction: column; } */
/* #steps > div > div { display: flex; align-items: center; margin-bottom: 5.88vw } */
/* #steps > div > div > h3 { } */
/* #steps > div > div > img { margin: 0 4.80vw 0 1.33vw; width: 3.53vw; height: 3.53vw;} */
/* #steps > div > div > label > input { margin: 0 4.80vw 0 1.33vw; width: 5.29vw; height: 5.29vw; border-radius: 5px; background: #f5f5f5; color: #222721 } */
/* #steps > div > div > span { color: rgba(19,21,21,.5019607843137255); font-size: 2.94vw} */
/* #steps > div > div > p { color: rgba(19,21,21,.5019607843137255); font-size: 2.94vw} */
/* #steps > div > div > label:last-child { color: rgba(19,21,21,.5019607843137255)} */
/* #steps > div > div > label > a { color: #43ac34; cursor: pointer } */
/* #steps > div > div > h1 { } */
/* #steps .nextStepBlock { display: flex; align-items: center; flex-direction: row; justify-content: space-between; } */
/* #steps .nextStepBlock > p { display: flex; align-items: center } */
/* #steps .nextStepBlock > button { border-radius: 2.67vw; width: 56vw; padding: 4.27vw; height: 12.27vw} */
/* #zform .sec_2 .pcOnly { display: none } */
/* #screenFormLayout{} */
/* .pcOnly { display: none } */
/* #anketaSteps { padding: 5.88vw ;position: relative} */
/* #screenFormLayout  h2 { margin-bottom: 11.47vw; font-size: 6.47vw } */
/* #zform { } */
/* .mobileOnly { display: block } */
/* .sec_2{position: relative} */
/* div.suggestions span { font-size: 4.41vw } */

/* /*.banner { background-image: url(../../../public/img/fin-moll_banner.svg); font-family: 'Ubuntu-Regular'; padding-top: 4.4vw; color: #FFFFFF; background-size: cover; padding-left: 5.88vw; padding-right: 5.88vw; position: relative }* / */
/* /*.banner svg { width: 40vw }* / */
/* /*.banner .phone { position: absolute; top: 27vw; right: 0 ;pointer-events: none}* / */
/* /*.banner .phone>img { width: 50vw }* / */
/* /*.banner>div>p:first-child { font-size: 4.48vw; font-weight: bold; margin-bottom: 5vw }* / */
/* /*.banner>div>p:nth-child(2) { font-size: 4vw; margin-bottom: 5vw; line-height: 6vw }* / */
/* /*.banner>div>p:nth-child(4) { font-size: 1.6vw; padding-bottom: 5vw; padding-top: 5vw }* / */
/* /*.banner>div>p>span { font-size: 4vw; background-color: #ABE600; color: #0f5740; font-weight: bold }* / */
/* /*.banner a{color:inherit}* / */

/* @media (min-width: 760px) { */
/*   /*стили для полей* / */
/*   .errorMsg { font-size: 0.81vw; top: 2.8vw; left: 0.28vw; } */
/*   .inputBoxWrap > input { padding: 0.89vw 1.61vw; border-radius: 10px; font-size: 1.13vw; margin-bottom: 1.29vw; color: #959595; width: calc(100% - 3.22vw);} */
/*   .inputBoxWrap label { font-size: 0.81vw; color: #959595; padding: 0} */
/*   input:focus ~ label { top: -0.5vw } */
/*   /deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -0.5vw } */
/*   /*остальные стили* / */

/*   h2 { font-size: 2.58vw } */
/*   h3 { color: #222721; font-size: 2.10vw } */
/*   p { font-size: 1.13vw } */
/*   a { color: #43AC34 } */
/*   span { font-size: 0.81vw } */
/*   div { font-size: 1.13vw } */
/*   button { font-size: 1.21vw } */
/*   label { font-size: 0.81vw } */
/*   div.suggestions span { font-size: 1.21vw } */

/*   .mobileOnly { display: none } */
/*   .pcOnly { display: block } */
/*   #steps > div { display: flex } */
/*   /*.align { width: 96.77vw; margin: 0 auto; }* / */
/*   .alignPDL { width: 96.77vw; margin: 0 auto; } */
/*   h2 { } */
/*   h3 { } */
/*   a { } */
/*   p { } */
/*   #zform .sec_2 .pcOnly { display: block } */
/*   #anketaSteps { display: flex; padding: 0; justify-content: space-between } */
/*   #screenFormLayout{ width: 58.87vw } */
/*   #screenFormLayout h2 { margin-bottom: 5.32vw; text-align: left; font-size: 1.94vw } */
/*   #steps { padding: 2.66vw 12.58vw 0 } */
/*   #steps > div { flex-direction: row; margin-bottom: 0 } */
/*   #steps > div > div { display: flex; align-items: center; padding-right: 3.15vw } */
/*   #steps > div > div > img { width: 1.45vw; height: 1.45vw; margin: 0 0.65vw 0 0 } */
/*   #steps > div > div > span { color: #131515; opacity: 0.5; padding-left: 0.65vw; font-size: 0.81vw } */
/*   #steps > div > div > label { } */
/*   #steps > div > div > p {  color: #131515; opacity: 0.5; padding-left: 0.65vw; font-size: 0.81vw } */
/*   #steps > div > div > label:last-child {  color: #131515; opacity: 0.5; padding-left: 0.65vw } */
/*   #steps > div > div > label > a { color: #43AC34 } */
/*   #steps > div > div > label > input { width: 1.45vw; height: 1.45vw; margin: 0 0.65vw 0 0} */
/*   #steps .nextStepBlock { margin-bottom: 4.27vw; justify-content: flex-end; } */
/*   #steps .nextStepBlock > p { display: flex; align-items: center } */
/*   #steps .nextStepBlock > button { border-radius: 10px; width: 16.13vw; padding: 1.29vw 2.10vw; height: 4.03vw; margin: 0 0 0 1.94vw } */

/*   /*.banner .mobileOnly {  display: block }* / */
/*   /*.banner .pcOnly {  display: none }* / */
/*   /*.banner {  padding-top: 6.18vw; padding-right: 7.50vw; padding-left: 7.50vw }* / */
/*   /*.banner svg { width: 30vw }* / */
/*   /*.banner .phone { top: 24vw; right: 2vw }* / */
/*   /*.banner .phone>img { width: 47vw }* / */
/*   /*.banner>div>p:first-child { font-size: 4.21vw; margin-bottom: 3vw }* / */
/*   /*.banner>div>p:nth-child(2) { font-size: 3.95vw; margin-bottom: 5.26vw; line-height: 6vw }* / */
/*   /*.banner>div>p:nth-child(4) { font-size: 1.5vw; padding-bottom: 3.95vw; padding-top: 3.95vw }* / */
/*   /*.banner>div>p>span { font-size: 3.95vw; background-color: #ABE600; color: #0f5740; font-weight: bold }* / */
/* } */
/* @media (min-width: 1240px) { */
/*   /*select,input{appearance: auto;}* / */
/*   /*стили для полей* / */
/*   .errorMsg { font-size: 10px; top: 36px; left: 23px; padding: 0 } */
/*   .inputBoxWrap > input { padding: 12px 20px; font-size: 14px; margin-bottom: 16px ;width: calc(100% - 40px);} */
/*   .inputBoxWrap label { font-size: 10px; left: 23px } */
/*   input:focus ~ label { top: -10px } */
/*   /deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -10px } */
/*   /*остальные стили* / */

/*   h2 { font-size: 29px } */
/*   h3 { color: #222721; font-size: 32px } */
/*   p { font-size: 14px } */
/*   a { color: #43AC34; font-size: 12px } */
/*   span { font-size: 10px } */
/*   div { font-size: 14px } */
/*   button { font-size: 15px } */
/*   label { font-size: 10px } */
/*   div.suggestions span { font-size: 15px } */

/*   .alignPDL { width: 1200px; margin: 0 auto; } */
/*   .mobileOnly { display: none } */
/*   .pcOnly { display: block } */
/*   #steps > div { display: flex } */
/*   a { } */
/*   #zform{padding: 20px 0;} */
/*   #zform .sec_2 .pcOnly { display: block } */
/*   #anketaSteps { padding: 0; } */
/*   #screenFormLayout{ width: 730px;margin:0 auto  } */
/*   #screenFormLayout h2 { margin-bottom: 40px ;font-size: 32px } */
/*   #steps { padding: 33px 110px 0 } */
/*   #steps > div { margin-bottom: 48px } */
/*   #steps > div > div { padding-right: 39px; margin-bottom: 0 } */
/*   #steps > div > div > img { width: 18px; height: 18px; margin: 0 8px 0 0 } */
/*   #steps > div > div > span { padding-left: 0 } */
/*   #steps > div > div > label {  padding-left: 0 } */
/*   #steps > div > div > p {  padding-left: 0; font-size: 10px } */
/*   #steps > div > div > label > a {  } */
/*   #steps > div > div > label > input { width: 18px; height: 18px; margin: 0 8px 0 0 } */
/*   #steps .nextStepBlock { margin-bottom: 53px } */
/*   #steps .nextStepBlock > p { } */
/*   #steps .nextStepBlock > button { width: 200px; padding: 16px 26px; height: 50px; margin: 0 0 0 30px } */

/*   /*.banner .mobileOnly { display: none }* / */
/*   /*.banner .pcOnly { display: block }* / */
/*   /*.banner { padding-top: 65px; padding-right: 0; padding-left: 0 }* / */
/*   /*.banner>div { position: relative; margin: 0 auto; width: 1200px }* / */
/*   /*.banner svg { width: 246px }* / */
/*   /*.banner .phone { position: absolute; top: -20px; right: 102px }* / */
/*   /*.banner .phone>img { width: 502px }* / */
/*   /*.banner>div>p:first-child { font-size: 32px; margin-bottom: 26px }* / */
/*   /*.banner>div>p:nth-child(2) { font-size: 30px; margin-bottom: 40px; line-height: 45px }* / */
/*   /*.banner>div>p:nth-child(4) { font-size: 12px; padding-bottom: 30px; padding-top: 40px }* / */
/*   /*.banner>div>p>span { font-size: 30px; background-color: #ABE600; color: #0f5740; font-weight: bold }* / */

/* } */

</style>
